import { makeStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import { useState } from 'react';
import ViewDeploymentsTableContainer from '../containers/ViewDeploymentsTableContainer';
import DeploymentFormContainer from '../containers/DeploymentFormContainer';
import { FormMode } from '../../../../types/formMode';

const useStyles = makeStyles({
  drawerPaper: {
    width: '60%',
  },
});

type FormOptions = {
  readonly show: boolean;
  readonly mode: FormMode;
  readonly resourceId?: string;
};

const INITIAL_FORM_OPTIONS: FormOptions = {
  show: false,
  mode: FormMode.VIEW,
};

const DeploymentConfiguration = () => {
  const classes = useStyles();

  const [formOptions, setFormOptions] = useState<FormOptions>(INITIAL_FORM_OPTIONS);
  const handleHideDeploymentForm = () => setFormOptions(INITIAL_FORM_OPTIONS);
  const handleShowDeploymentForm = (mode: FormMode, deploymentId?: string) => {
    setFormOptions({
      mode,
      show: true,
      resourceId: deploymentId,
    });
  };

  return (
    <>
      <ViewDeploymentsTableContainer
        showDeploymentForm={handleShowDeploymentForm}
      />
      <Drawer
        anchor='right'
        open={formOptions.show}
        onClose={handleHideDeploymentForm}
        classes={{ paper: classes.drawerPaper }}
      >
        <DeploymentFormContainer
          deploymentId={formOptions.resourceId || ''}
          hideDeploymentForm={handleHideDeploymentForm}
        />
      </Drawer>
    </>
  );
};

export default DeploymentConfiguration;
